var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import "../../components/header";
import "../../components/leftMenu";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/paging";
import * as ajax from "../../app-lib/ajax_proxy";
import './tipsInfo.css';
import '../../lib/knockout_datePicker';
import "../../components/tree";
import '../../lib/knockout_fileUpload';
// let id='';
var tipsInfo = /** @class */ (function (_super) {
    __extends(tipsInfo, _super);
    function tipsInfo(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.infoId = ko.observable(); //提醒id
        return _this;
    }
    // 获取数据
    tipsInfo.prototype.getInfo = function () {
        var _this = this;
        ajax.get('/api/message/' + this.infoId()).then(function (d) {
            _this.viewModel(d);
            console.log(_this.viewModel());
        });
    };
    // 返回
    tipsInfo.prototype.goBack = function () {
        history.go(-1);
    };
    return tipsInfo;
}(KnockoutModel));
var DemoModel = /** @class */ (function (_super) {
    __extends(DemoModel, _super);
    function DemoModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DemoModel.prototype.init = function () {
        this.vm = new tipsInfo(this.container.querySelector('.tipsInfo'));
        this.vm.bind();
    };
    DemoModel.prototype.update = function (arg) {
        this.vm.infoId(arg.routeData.query.id);
        this.vm.getInfo();
        return Promise.resolve();
    };
    DemoModel.prototype.onInitComplete = function () {
    };
    return DemoModel;
}(Page));
export default DemoModel;
